import { appUpgradeLoadingState, paymentModalOpenState, subscriptionOfferingsState, userDataState } from "@/lib/store";
import { Purchases } from "@revenuecat/purchases-capacitor";
import { useCallback, useRef } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

const useHandleAppUpgrade = () => {
    const offerings = useRecoilValue(subscriptionOfferingsState);
    const offeringsRef = useRef<any>(null);
    offeringsRef.current = offerings;

    const userData = useRecoilValue(userDataState);
    const setAppUpgradeLoading = useSetRecoilState(appUpgradeLoadingState);
    const setPaymentModalOpen = useSetRecoilState(paymentModalOpenState);

    const handleAppUpgrade = useCallback(
        async (selectedPackage?: any) => {
            const currentOfferings = offeringsRef.current;
            const packageToUse = selectedPackage ?? (Array.isArray(currentOfferings) ? currentOfferings[0] : null);
            try {
                setAppUpgradeLoading(true);
                const purchaseResponse = await Purchases.purchasePackage({
                    aPackage: packageToUse,
                });
                await Purchases.setDisplayName({ displayName: userData?.first_name + " " + userData?.last_name });
                await Purchases.setEmail({ email: userData.email });
            } catch (error) {
                console.error("Purchase failed:", error);
            } finally {
                setAppUpgradeLoading(false);
                setPaymentModalOpen(false);
            }
        },
        [userData, setAppUpgradeLoading, setPaymentModalOpen]
    );

    return { handleAppUpgrade };
};

export default useHandleAppUpgrade;
